function initCustomVideoPlayer() {

  const wrappers = document.querySelectorAll('.product__video-wrapper');

  if (!wrappers.length) return;

  const videos = Array.from(
    document.querySelectorAll('.product__video')
  );

  /* ── pause all except current ── */
  function pauseAllExcept(current) {

    videos.forEach((v) => {

      if (v !== current) {

        v.pause();

        const parent =
          v.closest('.product__video-wrapper');

        parent?.classList.remove('is-playing');

      }

    });

  }

  wrappers.forEach((wrapper) => {

    if (wrapper.dataset.initialized) return;

    wrapper.dataset.initialized = 'true';

    const video =
      wrapper.querySelector('.product__video');

    const playBtn =
      wrapper.querySelector('.product__video--play');

    const seek =
      wrapper.querySelector('.product__video--seek');

    if (!video) return;

    /* force first frame on iOS */
    video.addEventListener('loadedmetadata', () => {

      try {
        video.currentTime = 0.01;
      } catch (e) {}

    });

    // video.addEventListener('seeked', () => {

    //   if (!wrapper.classList.contains('is-playing')) {
    //     video.pause();
    //   }

    // });

    /* ── play / pause ── */
    function togglePlay() {

      if (video.paused) {

        pauseAllExcept(video);

        video.play();

        wrapper.classList.add('is-playing');

      } else {

        video.pause();

        wrapper.classList.remove('is-playing');

      }

    }

    /* play button */
    playBtn?.addEventListener('click', (e) => {

      e.stopPropagation();

      togglePlay();

    });

    /* click on video */
    video.addEventListener('click', togglePlay);

    /* update seekbar */
    video.addEventListener('timeupdate', () => {

      if (video.duration) {

        seek.value =
          (video.currentTime / video.duration) * 100;

      }

    });

    /* seek */
    seek?.addEventListener('input', () => {

      if (video.duration) {

        video.currentTime =
          (seek.value / 100) * video.duration;

      }

    });

    /* pause state */
    video.addEventListener('pause', () => {

      wrapper.classList.remove('is-playing');

    });

    /* ended state */
    video.addEventListener('ended', () => {

      wrapper.classList.remove('is-playing');

    });

  });

  /* ── auto pause when out of view ── */
  const io = new IntersectionObserver((entries) => {

    entries.forEach((entry) => {

      if (entry.intersectionRatio < 0.5) {

        const video = entry.target;

        video.pause();

        video
          .closest('.js-reel-video')
          ?.classList.remove('is-playing');

      }

    });

  }, {
    threshold: [0.5]
  });

  videos.forEach((video) => {
    io.observe(video);
  });

}

document.addEventListener(
  'DOMContentLoaded',
  initCustomVideoPlayer
);

document.addEventListener(
  'shopify:section:load',
  initCustomVideoPlayer
);



function initAuraProductGallery() {

  const galleries = document.querySelectorAll('.product-info .product-gallery');

  if (!galleries.length) return;

  const isDesktop = window.matchMedia('(min-width: 992px)').matches;

  galleries.forEach((gallery) => {

    const mainSlider =
      gallery.querySelector('.js-gallery-main');

    const thumbSlider =
      gallery.querySelector('.js-thumb-slider');

    if (!mainSlider || !thumbSlider) return;

    const isDesktopGallery = gallery.classList.contains('product-gallery--desktop');
    const shouldInit = isDesktop ? isDesktopGallery : !isDesktopGallery;

    /* destroy existing swiper */
    if (mainSlider.swiper) {
      mainSlider.swiper.destroy(true, true);
    }

    if (thumbSlider.swiper) {
      thumbSlider.swiper.destroy(true, true);
    }

    if (!shouldInit) return;

    /* THUMB SLIDER */
    const thumbs = new Swiper(thumbSlider, {

      spaceBetween: 12,
      watchSlidesProgress: true,
      loop: false,
      freeMode: true,
      mousewheel: true,
      speed: 800,
      breakpoints: {
        0: {
          direction: 'horizontal',
          slidesPerView: 4.5,
        },

        992: {
          direction: 'vertical',
          slidesPerView: 4,
        }

      }

    });

    /* MAIN SLIDER */
    const main = new Swiper(mainSlider, {
       loop: false,
      speed: 800,
      slidesPerView: 1,
      effect: 'fade',
      breakpoints: {
        0: {          
          autoHeight: true,
        },
        992: {          
          autoHeight: false,
        }
      },
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: thumbs
      }

    });

    /* pause videos in this gallery */
    function pauseGalleryVideos() {

      gallery
        .querySelectorAll('.product__video')
        .forEach((video) => {

          video.pause();

          video
            .closest('.product__video-wrapper')
            ?.classList.remove('is-playing');

        });

    }

    /* change slide */
    main.on('slideChange', function () {

      pauseGalleryVideos();

    });

  });

}

if (!window.__auraGalleryBreakpointBound) {
  window.__auraGalleryBreakpointBound = true;
  window.matchMedia('(min-width: 992px)').addEventListener('change', function () {
    initAuraProductGallery();
  });
}

function formatVariantMoney(cents) {
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(
      cents,
      window.theme && window.theme.moneyFormat
        ? window.theme.moneyFormat
        : Shopify.money_format
    );
  }

  return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function extractAffirmMonthlyLabel(root) {
  var scope = root || document;

  // Prefer the product ALA we control; then any populated Affirm node on the page.
  var candidates = [];
  var primary = scope.querySelector('.product-info__affirm-ala') || document.querySelector('.product-info__affirm-ala');
  if (primary) candidates.push(primary);

  document.querySelectorAll('.affirm-as-low-as').forEach(function (el) {
    if (candidates.indexOf(el) === -1) candidates.push(el);
  });

  for (var i = 0; i < candidates.length; i++) {
    var ala = candidates[i];
    var priceEl =
      ala.querySelector('.affirm-ala-price') ||
      ala.querySelector('[class*="ala-price"]') ||
      ala.querySelector('span');
    var text = ((priceEl && priceEl.textContent) || ala.textContent || '').replace(/\s+/g, ' ').trim();
    // Match $139, $1,399, $139.00 — ignore em-dash placeholders
    var match = text.match(/\$\s*[\d,]+(?:\.\d{1,2})?/);
    if (match) {
      return match[0].replace(/\s+/g, '').replace(/\.00$/, '');
    }
  }

  return null;
}

function syncAffirmMonthlyLabels(root) {
  var amount = extractAffirmMonthlyLabel(root);
  if (!amount) return false;

  var inlineLabel = amount + '/mo';
  var buttonLabel = amount + '/MO';

  document.querySelectorAll('[data-affirm-monthly-inline]').forEach(function (el) {
    el.textContent = inlineLabel;
  });

  document.querySelectorAll('[data-affirm-monthly-label]').forEach(function (el) {
    el.textContent = buttonLabel;
  });

  document.querySelectorAll('[data-affirm-text]').forEach(function (el) {
    var template = el.getAttribute('data-affirm-text-template');
    if (template) {
      el.textContent = template.replace('{{amount}}', inlineLabel);
    }
  });

  return true;
}

function observeAffirmAla(root) {
  var scope = root || document;
  var ala = scope.querySelector('.product-info__affirm-ala') || document.querySelector('.product-info__affirm-ala');
  if (!ala || ala.dataset.affirmObserved === 'true') return;

  ala.dataset.affirmObserved = 'true';

  var observer = new MutationObserver(function () {
    syncAffirmMonthlyLabels(scope);
  });

  observer.observe(ala, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

function refreshAffirmPromos(amountCents, root) {
  var scope = root || document;
  var hasAmount = amountCents !== null && amountCents !== undefined && amountCents !== '';

  observeAffirmAla(scope);

  if (hasAmount) {
    var amount = String(amountCents);

    document.querySelectorAll('.affirm-as-low-as, .js-affirm-learn-more, [data-conversion-affirm]').forEach(function (el) {
      el.setAttribute('data-amount', amount);
    });
  }

  function afterRefresh() {
    var tries = 0;
    var timer = setInterval(function () {
      var done = syncAffirmMonthlyLabels(scope);
      tries += 1;
      if (done || tries >= 40) clearInterval(timer);
    }, 250);
  }

  function runRefresh() {
    try {
      if (window.affirm && affirm.ui && typeof affirm.ui.refresh === 'function') {
        affirm.ui.refresh();
      }
    } catch (e) {}
    afterRefresh();
  }

  if (window.affirm && affirm.ui && typeof affirm.ui.ready === 'function') {
    affirm.ui.ready(runRefresh);
  } else {
    var waitTries = 0;
    var waitTimer = setInterval(function () {
      waitTries += 1;
      if (window.affirm && affirm.ui && typeof affirm.ui.ready === 'function') {
        clearInterval(waitTimer);
        affirm.ui.ready(runRefresh);
      } else if (waitTries >= 60) {
        clearInterval(waitTimer);
        afterRefresh();
      }
    }, 250);
  }
}

function openAffirmModal() {
  var trigger =
    document.querySelector('.product-info__affirm-ala .affirm-modal-trigger') ||
    document.querySelector('.affirm-as-low-as .affirm-modal-trigger') ||
    document.querySelector('.product-info__affirm-ala a') ||
    document.querySelector('.affirm-as-low-as a');

  if (trigger) {
    trigger.click();
    return true;
  }

  if (window.affirm && affirm.ui && typeof affirm.ui.ready === 'function') {
    affirm.ui.ready(function () {
      affirm.ui.refresh();
    });
  }

  return false;
}

function openTruemedModal() {
  var trigger =
    document.querySelector('#truemed-instructions .truemed-instructions-open') ||
    document.querySelector('#truemed-instructions .truemed-entry-link') ||
    document.querySelector('.truemed-instructions-open') ||
    document.querySelector('.truemed-entry-link') ||
    document.querySelector('#truemed-instructions button') ||
    document.querySelector('#truemed-instructions a');

  if (trigger) {
    // Temporarily enable pointer events if the widget UI is hidden.
    var host = document.getElementById('truemed-instructions');
    var prevPointer = host ? host.style.pointerEvents : null;
    if (host) host.style.pointerEvents = 'auto';
    trigger.click();
    if (host) host.style.pointerEvents = prevPointer || '';
    return true;
  }

  return false;
}

function initAffirmLearnMoreButtons() {
  if (window.__sstAffirmClickBound) return;
  window.__sstAffirmClickBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-affirm-learn-more');
    if (!btn) return;
    event.preventDefault();
    openAffirmModal();
  });
}

function initTruemedLearnMoreButtons() {
  if (window.__sstTruemedClickBound) return;
  window.__sstTruemedClickBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-truemed-learn-more');
    if (!btn) return;
    event.preventDefault();

    if (openTruemedModal()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (openTruemedModal() || tries >= 20) clearInterval(timer);
    }, 250);
  });
}

function getCartAddUrl() {
  var root = window.Shopify && Shopify.routes && Shopify.routes.root;

  return (root || '/') + 'cart/add.js';
}

function initAuraProductForm() {
  var section = document.querySelector('.product-info');
  if (!section) return;

  var productJsonEl = section.querySelector('[id^="ProductJson-"]');
  var form = section.querySelector('.js-product-form');
  var variantInput = section.querySelector('.product-info__variant-id');
  var optionSelects = section.querySelectorAll('.product-info__variant-select');
  var priceCurrent = section.querySelector('.product-info__price-current');
  var priceCompare = section.querySelector('.product-info__price-compare');
  var addButton = section.querySelector('.product-info__add-to-cart, .product-info__buy-buttons .btn');
  var quantityInput = section.querySelector('.product-info__quantity-input');

  if (!form || !variantInput) return;

  var variants = productJsonEl ? JSON.parse(productJsonEl.textContent) : [];

  function findVariantById(id) {
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  function updateUiForVariant(variant) {
    if (!variant) return;

    variantInput.value = String(variant.id);

    if (priceCurrent) {
      priceCurrent.textContent = formatVariantMoney(variant.price);
    }

    if (priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatVariantMoney(variant.compare_at_price);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }

    if (addButton) {
      addButton.disabled = !variant.available;
    }

    refreshAffirmPromos(variant.price, section);

    document.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: { variant: variant },
      })
    );
  }

  function syncVariantFromOptions() {
    var options = Array.prototype.map.call(optionSelects, function (select) {
      return select.value;
    });

    var match = variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    });

    if (match) {
      updateUiForVariant(match);
    }
  }

  if (optionSelects.length && variants.length) {
    optionSelects.forEach(function (select) {
      select.addEventListener('change', syncVariantFromOptions);
    });

    syncVariantFromOptions();
  } else {
    updateUiForVariant(findVariantById(variantInput.value));
  }

  if (form.dataset.cartSubmitBound === 'true') return;
  form.dataset.cartSubmitBound = 'true';

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var variantId = parseInt(variantInput.value, 10);
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!variantId || quantity < 1) return;

    if (addButton) {
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
    }

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw data;
          }

          return data;
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
      })
      .catch(function (error) {
        var message =
          (error && error.description) ||
          (error && error.message) ||
          'Unable to add this item to your cart. Please try again.';

        alert(message);
      })
      .finally(function () {
        if (addButton) {
          var currentVariant = findVariantById(variantInput.value);
          addButton.disabled = currentVariant ? !currentVariant.available : false;
          addButton.removeAttribute('aria-busy');
        }
      });
  });
}

function initBundleAtcButtons() {
  document.querySelectorAll('.js-bundle-atc').forEach(function (btn) {
    if (btn.dataset.bundleAtcBound === 'true') return;
    btn.dataset.bundleAtcBound = 'true';

    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId || btn.disabled) return;

      var label = btn.dataset.label || btn.textContent;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          btn.textContent = '✓ Added to Cart!';
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
        })
        .catch(function (error) {
          var message =
            (error && error.description) ||
            (error && error.message) ||
            'Unable to add this item to your cart. Please try again.';
          alert(message);
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initAuraProductGallery();
  initAuraProductForm();
  initBundleAtcButtons();
  initAffirmLearnMoreButtons();
  initTruemedLearnMoreButtons();

  var productSection = document.querySelector('.product-info');
  var ala = document.querySelector('.product-info__affirm-ala');
  if (ala) {
    observeAffirmAla(productSection || document);
    refreshAffirmPromos(ala.getAttribute('data-amount'), productSection || document);
  }
});

document.addEventListener('affirm:ready', function () {
  var productSection = document.querySelector('.product-info');
  var ala = document.querySelector('.product-info__affirm-ala');
  if (!ala) return;
  observeAffirmAla(productSection || document);
  refreshAffirmPromos(ala.getAttribute('data-amount'), productSection || document);
});

document.addEventListener('shopify:section:load', function () {
  initAuraProductGallery();
  initAuraProductForm();
  initBundleAtcButtons();
  initAffirmLearnMoreButtons();
  initTruemedLearnMoreButtons();

  var productSection = document.querySelector('.product-info');
  var ala = document.querySelector('.product-info__affirm-ala');
  if (ala) {
    ala.dataset.affirmObserved = '';
    observeAffirmAla(productSection || document);
    refreshAffirmPromos(ala.getAttribute('data-amount'), productSection || document);
  }
});


$(document).ready(function() {  
(function (e, t) {
  if (e.length)
  for (var o = 0; o < e.length; o++) {
      e[o].addEventListener("click", function () {
          var e = this.dataset.scroll_to,
              o = this.dataset.scroll_spacer;
          t("html, body").animate({ scrollTop: t(e).offset().top - o }, 1e3);
          
      });
  }
})(document.querySelectorAll(".js-scrollto"), jQuery);
});